import { render } from "./RecurrenceEditor.vue?vue&type=template&id=5038fa72&scoped=true&ts=true&lang=pug"
import script from "./RecurrenceEditor.vue?vue&type=script&lang=ts"
export * from "./RecurrenceEditor.vue?vue&type=script&lang=ts"

import "./RecurrenceEditor.vue?vue&type=style&index=0&id=5038fa72&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5038fa72"]])

export default __exports__